import PostcardList from "../components/PostcardsListComponent/";
import NotFound from "../components/NotFoundComponent";
const routesAddresses = {
  POSTCARDS: "/",
  NOT_FOUND: "/",
}

const routes = [
  { address: routesAddresses.POSTCARDS, component: PostcardList, exact: true },
]

const notFoundRoute = {
  address: routesAddresses.NOT_FOUND,
  component: NotFound,
}

const defaultRoute = routesAddresses.POSTCARDS

export {
  routes,
  notFoundRoute,
  defaultRoute
}